module.exports = __webpack_public_path__ + "static/media/56-christmas.ba27f20b.jpeg";